import { render, staticRenderFns } from "./CIEAttachments.vue?vue&type=template&id=7621262f&"
import script from "./CIEAttachments.vue?vue&type=script&lang=js&"
export * from "./CIEAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports